module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"price":{"label":"Discount","placeholder":"0"},"percentage":{"label":"Discount","placeholder":"1 - 100"},"save":"save","back":"back"}}')
  delete Component.options._Ctor
}
